export type Inbox = {
    id: number;
    description: string;
    created_at: string;
    is_read: boolean;
    type: InboxType;
    transaction_details: TransactionDetails | null;
}

export type TransactionDetails = {
    user: number | null;
    transaction: string | null;
} 

export enum InboxType {
    Transaction = 'transaction',
    Exchange = 'exchange',
    Setting = 'setting'
}

export type InboxNotificationStatus = {
    notifications: number[];
    read: boolean;
}